import React, { useEffect, useState, useContext, useLayoutEffect } from "react";
import styled from "styled-components";
import DataListBody from "../components/DataList/DataListBody";
import DataListTitle from "../components/DataList/DataListTitle";
import { useQuery } from "react-query";
import axios from "axios";

import { Pagination } from "@mui/material";
import Footer from "../components/Footer";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingModal from "../components/Modal/LoadingModal";
import Logger from "../libraries/Logger";
import apiClient from "../libraries/ApiClient";
import fake from "../libraries/FakeApiClient";
import FakeApiClient from "../libraries/FakeApiClient";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { AuthContext } from "../contexts/AuthContext";
import dayjs from "dayjs";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 95%;
  height: calc(100% - 50px);
  position: relative;
  .table {
    width: 100%;
    max-height: calc(100% - 210px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .pagination {
    height: 100px;
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    position: absolute;
    bottom: 0px;
  }
  @media (max-width: 1200px) {
    .table {
      max-height: 100%;
      overflow-y: visible;
    }
    .pagination {
      position: static;
    }
  }
`;

function ReferralDataList({ lineUserId }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [tokenCheck, setTokenCheck] = useState("");
  const [nowPageNumber, setNowPageNumber] = useState(1);
  const { logout } = useContext(AuthContext);
  useEffect(() => {
    setTokenCheck(JSON.parse(localStorage.getItem("auth"))?.Token);
    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    const version = import.meta.env.VITE_VERSION;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    if (token === undefined) {
      navigate("/Login");
    }

    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });
  }, []);
  // Logger.LogOfInfoWithIdentity("清單頁Token", token);

  const getListData = async ({ queryKey }) => {
    const data = {
      Data: { CurrentPage: queryKey[2], PageSize: 15 },
    };

    const result = await apiClient.postAes("api/referral/List/Security", data);

    if (result?.status === 401) {
      alert("您的授權已失效，請重新登入");
      logout();
      navigate("/Login");
      return;
    } else {
      return result.data;
    }
  };

  const handlePageChange = (event, value) => {
    setNowPageNumber(value);
  };

  const { data, isLoading } = useQuery(
    ["getListData", tokenCheck, nowPageNumber],
    getListData,
    {
      enabled: !!tokenCheck,
      refetchOnWindowFocus: false,
    }
  );

  const getVersionData = async () => {
    const res = await axios.get(
      `${import.meta.env.VITE_API_ROOT_URL}api/login/version`
    );
    return res?.data;
  };

  const { data: versionData } = useQuery("getVersionData", getVersionData, {
    onSuccess: (versionData) => {
      if (versionData === "") {
        return;
      } else {
        if (versionData !== import.meta.env.VITE_VERSION) {
          alert("偵測到有新的版本，將為您重整網頁");
          window.location.reload(true);
        }
      }
    },
  });

  return (
    <Container>
      <LoadingModal isOpen={isLoading} />
      <DataListTitle />
      <div className="table">
        <DataListBody data={data?.Data} />
      </div>
      <div className="pagination">
        <Pagination
          count={data?.Data?.PageCount}
          showFirstButton
          showLastButton
          page={nowPageNumber}
          onChange={handlePageChange}
          siblingCount={0}
          boundaryCount={2}
        />
        <Footer />
      </div>
    </Container>
  );
}

export default ReferralDataList;
